import React, { useEffect, useState } from "react";
import FormWithHeader from "../../Components/FormView/FormWithHeader";
import { Box, Typography } from "@mui/material";
import ButtonTabs from "../../Components/ButtonTabs/ButtonTabs";
import LoanModuleHomePage from "./LoanModuleHomePage";
import ApplyLoan from "./ApplyLoan";
import LAPersonalDetails from "../LoanApplication/LAPersonalDetails";
import LALoanDetails from "../LoanApplication/LALoanDetails";
import BankDetails from "../LoanApplication/BankDetails";
import SurityDetails from "../LoanApplication/SurityDetails";
import { useLocation } from "react-router-dom";
import { getContext } from "../../Helpers/Context/Context";
import AgreementDetails from "../LoanApplication/AgreementDetails";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      aria-disabled={false}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const LoanApplication = (props) => {
  const { next } = props;
  const context = getContext();
  const { state } = useLocation();
  const [value, setValue] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [stepsststatus, setStepStatus] = useState(0);
  const [tabsStatus, setTabsStatus] = React.useState([
    false,
    true,
    true,
    true,
    true,
  ]);
  const tabs = [
    {
      label: "Personal Details",
      value: { ...a11yProps(0) },
      disabled: tabsStatus[0],
    },
    {
      label: "Loan Details",
      value: { ...a11yProps(1) },
      disabled: tabsStatus[1],
    },
    {
      label: "Bank Details",
      value: { ...a11yProps(2) },
      disabled: tabsStatus[2],
    },
    {
      label: "Surety Details",
      value: { ...a11yProps(3) },
      disabled: tabsStatus[3],
    },
    // {
    //   label: "Agreement Details",
    //   value: { ...a11yProps(4) },
    //   disabled: tabsStatus[4],
    // },
  ];

  useEffect(() => {
    activateEnableTabs();
  }, []);

  const activateEnableTabs = () => {
    // Redirect To Loan detail
   

    if (
      props?.statusData?.Lrd_CurrentMonthSalarySlipDocId != null &&
      props?.statusData?.Lrd_CurrentMonthSalarySlipDocId != 0
    ) {
      setTabsStatus([false, true, true, true]);
      setValue(1);
    }
    //  Redirect To Bank detail
    if (
      props?.statusData?.Lrd_Reason != 0 &&
      props?.statusData?.Lrd_Reason != null
    ) {
      setTabsStatus([false, false, true, true]);
      setValue(2);
    }
    // Surity detail
    if (
      props?.statusData?.Lrd_CancelChequePassbookDocId != null &&
      props?.statusData?.Lrd_CancelChequePassbookDocId != 0
    ) {
      setTabsStatus([false, false, false, false]);
      setValue(3);
    }
    if (
      props?.statusData?.Lrd_StatusId ==
      LoanStatus.LoanModule_RejectedByInternalTeam
    ) {
      setTabsStatus([false, false, false, false]);
      setValue(0);
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // setTabsStatus((prevStatus) => prevStatus.map((_, index) => index <= newValue));
  };

  const selectNextTab = (index: any) => {
    // getMemberIdStatusDetails().finally(() => {
    let val = value + 1;
    setValue(val);
    setTabsStatus((prevStatus) =>
      prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true)))
    );
    // });
  };

  const selectPreviousTab = (index: any) => {
    setValue(value - 1);

    setTabsStatus((prevStatus) =>
      prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true)))
    );
  };

  return (
    <div>
      {/* <FormWithHeader title="Step 2 : Loan Application"> */}
      <Box sx={{ width: "100%" }}>
        <ButtonTabs value={value} handleChange={handleChange} tabs={tabs} />
        <CustomTabPanel value={value} index={0}>
          <LAPersonalDetails
            selectNextTab={(index) => selectNextTab(1)}
            selectPreviousTab={selectPreviousTab}
            // statusData={statusData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <LALoanDetails
            selectNextTab={() => selectNextTab(2)}
            selectPreviousTab={(index) => selectPreviousTab(0)}
            // statusData={statusData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <BankDetails
            selectNextTab={() => selectNextTab(3)}
            selectPreviousTab={(index) => selectPreviousTab(1)}
            // statusData={statusData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <SurityDetails
            selectNextTab={next}
            selectPreviousTab={(index) => selectPreviousTab(2)}
            // statusData={statusData}
          />
        </CustomTabPanel>
        {/* <CustomTabPanel value={value} index={4}>
          <AgreementDetails
            selectNextTab={next}
            selectPreviousTab={(index) => selectPreviousTab(3)}
            // statusData={statusData}
          />
        </CustomTabPanel> */}
      </Box>
      {/* </FormWithHeader> */}
    </div>
  );
};

export default LoanApplication;
